module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'load-cancelled': _vm.decorated.status_text === 'Cancelled'
    }
  }, [_c('p', {
    staticClass: "load-reference"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'loads.show',
        params: {
          id: _vm.load.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.load.reference_number))]), _vm._v("\n    - " + _vm._s(_vm.decorated.size) + "\n  ")], 1), _vm._v(" "), _c('span', {
    staticClass: "status text-primary",
    class: _vm.decorated.status_class
  }, [_vm._v(_vm._s(_vm.decorated.status_text))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.decorated.registration) + " - " + _vm._s(_vm.decorated.company))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Loading " + _vm._s(_vm.decorated.loading_date) + " at " + _vm._s(_vm.decorated.loading_time))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-cb591584"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/JobLoad.vue
// module id = 1076
// module chunks = 0